import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "./cn";

export const inputClassName =
  "flex h-(--control-h) w-full rounded-md border border-border-strong bg-surface px-3 text-body text-fg transition-colors duration-120 placeholder:text-fg-faint disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-danger";

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(function Input(
  { className, type = "text", ...props },
  ref,
) {
  return <input ref={ref} type={type} className={cn(inputClassName, className)} {...props} />;
});
